import { apiManager } from "./apiManager";

export const profileApi = {
    getProfileData: async () => await apiManager.get("/dashboard/profile"),
    getAuthUserTours: async (queryStr) => await apiManager.get(`/dashboard/profile/tours${queryStr ?? ''}`),
    updateProfile: async (body) => await apiManager.post("/dashboard/profile/update", body),
    changePasswor: async (body) => await apiManager.put("/dashboard/profile/change-password", body),
}